import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPageContent } from '../../Apis/content';

export const Homepage = createAsyncThunk('homepages', async (formData, { rejectWithValue }) => {
    try {
        const response = await getPageContent(formData);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});

const homepageSlice = createSlice({
    name: 'homepage',
    initialState: {
        error: null,
        success: false,
        data: {}
    },
    reducers: {
        clearHomepageStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(Homepage.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(Homepage.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(Homepage.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearHomepageStatus } = homepageSlice.actions;
export default homepageSlice.reducer;

